import { POST } from '@/api'

const MAX_WIDTH = 1424
const MAX_HEIGHT = 960
const DEFAULT_VIEW_BOX = `${MAX_WIDTH / 4} ${MAX_HEIGHT / 4} ${MAX_WIDTH / 2} ${MAX_HEIGHT / 2}`

const initialLayout = {
  id: null,
  name: 'レイアウト１',
  floors: [],
}

const initialFloor = {
  id: 1,
  name: 'フロア１',
  tables: [],
  parts: [],
  viewBox: DEFAULT_VIEW_BOX,
}

export default {
  namespaced: true,
  state: {
    layout: {
      id: null,
      name: '',
      floors: [],
    },
    busy: false,
  },
  mutations: {
    set(state, layout) {
      const floors = layout ? layout.floors.map(floor => ({ ...initialFloor, ...floor })) : [initialFloor]
      state.layout = { ...(layout || initialLayout), floors }
    },
    busy(state, value) {
      state.busy = value
    },
  },
  actions: {
    async get(store, id) {
      const { commit } = store
      commit('busy', true)

      const { status, message, data } = await POST('/api/web/layouts/detail', { id })

      if (status === 200) {
        commit('set', data.layout)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
  },
}
